import { Reveal, SectionLabel } from "./Reveal";
import { IMAGES } from "@/lib/site";
import { Check } from "lucide-react";

const POINTS = [
  "Singapore-headquartered enterprise software company",
  "A subsidiary of global technology leader ByteDance",
  "Trusted by organizations across 150+ countries",
];

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <Reveal>
        <div className="relative">
          <div className="relative rounded-[24px] overflow-hidden shadow-[0_24px_60px_rgba(15,23,42,0.10)] border border-gray-100">
            <img src={IMAGES.team2} alt="Lark team at work" className="w-full h-[420px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-6 rounded-2xl bg-lark-blue text-white px-6 py-5 shadow-[0_16px_40px_rgba(22,119,255,0.35)]">
            <p className="font-display text-2xl font-semibold leading-none">ByteDance</p>
            <p className="text-xs text-white/80 mt-1.5">Subsidiary company</p>
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <SectionLabel>About Us</SectionLabel>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-display text-4xl md:text-5xl font-semibold tracking-tight text-lark-ink leading-[1.1]">
            Enterprise software, engineered in Singapore
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-lark-muted">
            Lark Technologies Pte. Ltd. is a Singapore-headquartered enterprise software
            company and a subsidiary of the global technology conglomerate ByteDance. We
            build modern, cloud-based products that unify how the world's most ambitious
            organizations communicate and collaborate.
          </p>
        </Reveal>
        <ul className="mt-8 space-y-4">
          {POINTS.map((p, i) => (
            <Reveal key={p} delay={0.12 + i * 0.07}>
              <li className="flex items-start gap-3" data-testid={`about-point-${i}`}>
                <span className="mt-0.5 grid place-items-center h-6 w-6 rounded-full bg-lark-light text-lark-blue shrink-0">
                  <Check size={14} strokeWidth={3} />
                </span>
                <span className="text-lark-ink font-medium">{p}</span>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </div>
  </section>
);
